import $ from 'gridstrap/lib/gs-zepto';
import analytics from 'gridstrap/lib/gs-analytics';

export class GSTableOfContentsFilter {

	//
	// Properties
	//

	private root;
	private input;
	private tableOfContents;

	get for() { return this.root.data('gsTableOfContentsFilterFor') || 'TableOfContents'; }

	get value() { return this.input.val().trim(); }
	set value(value) { this.input.val(value.trim()); }

	//
	// Methods
	//

	trackPageview() {
		let path  = location.pathname;
		let query = escape(this.value);
		let url   = `${path}?q=${query}`;
		analytics.pageview(url);
	}

	//
	// Initializations & Event Listeners
	//

	constructor(root) {
		this.root = $(root);
		this.input = this.root.find('.gs-TableOfContentsFilter-input');
		this.tableOfContents = $(`#${this.for}`);
		this.input.on({
			keyup: evt => this.handleKeypress(evt),
			blur: () => this.trackPageview()
		});
		this.input.on('')
	}

	handleKeypress(evt) {
		const isEscape = (evt.which || evt.keyCode) === 27;
		if (isEscape && this.value == '') return this.input.blur();
		if (isEscape && this.value != '') this.value = '';
		this.tableOfContents.gs('filter', this.value);
	}
}
